import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
import Icon from '../AppIcon';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info', duration = 3000) => {
    const id = Date.now();
    setToasts((prevToasts) => [...prevToasts, { id, message, type, duration }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <div className="fixed bottom-4 right-4 z-50 space-y-2">
        {toasts.map((toast) => (
          <Toast key={toast.id} {...toast} onRemove={() => removeToast(toast.id)} />
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  return useContext(ToastContext);
};

const Toast = ({ id, message, type, duration, onRemove }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onRemove(id);
    }, duration);

    return () => {
      clearTimeout(timer);
    };
  }, [duration, id, onRemove]);

  const iconMap = {
    info: 'Info',
    success: 'CheckCircle',
    warning: 'AlertTriangle',
    error: 'AlertCircle',
  };

  const colorMap = {
    info: 'bg-blue-500',
    success: 'bg-green-500',
    warning: 'bg-yellow-500',
    error: 'bg-red-500',
  };

  return (
    <div
      className={`flex items-center justify-between p-3 rounded-md shadow-lg text-white ${colorMap[type]} transition-all duration-300 ease-out transform translate-x-0 opacity-100`}
      role="alert"
    >
      <div className="flex items-center space-x-2">
        <Icon name={iconMap[type]} size={20} />
        <span>{message}</span>
      </div>
      <button onClick={() => onRemove(id)} className="ml-4 p-1 rounded-full hover:bg-white/20 transition-colors">
        <Icon name="X" size={16} />
      </button>
    </div>
  );
};
